import { dispatcher } from "@quest/base-core";
import { SettingPannelController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class SettingPanelController extends SettingPannelController {

    /**
   * Override to update Jackpot Meter Value
   */
  protected onMaxBetPressUp(): void {
    super.onMaxBetPressUp();
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METER_VALUE);

  }

  /**
   * Override to update Jackpot Meter Value
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METER_VALUE);
  }

}
